export default __webpack_public_path__ + "static/media/nehru02.edc82f6f.jpg";